import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGear } from '@fortawesome/pro-solid-svg-icons/faGear'
import { useTranslation } from 'react-i18next'
import { Button } from 'antd'
import { useState } from 'react'
import { IQuestionBankSection } from 'interfaces/questionBank'
import Information from '../information'
import { Wrapper } from './styled'
import AdjustQuestions from './adjustQuestions'

interface IProps {
  section: IQuestionBankSection
}

const Footer = ({ section }: IProps) => {
  const { t } = useTranslation()
  const translationPrefix = 'administration.blocks.type.questionBankV2.sections'
  const [isAdjustingQuestions, setIsAdjustingQuestions] = useState(false)

  return (
    <>
      <Wrapper>
        <Button onClick={() => setIsAdjustingQuestions(true)}>
          <FontAwesomeIcon icon={faGear} />
          {t(`${translationPrefix}.actions.adjustQuestions`)}
        </Button>
        <Information section={section} />
      </Wrapper>
      {isAdjustingQuestions && (
        <AdjustQuestions
          section={section}
          close={() => setIsAdjustingQuestions(false)}
        />
      )}
    </>
  )
}

export default Footer
